export enum ChangeRequestStatusType {
    NewCancellationRequest = 27,
    CancellationPending = 28,
    CancellationCompleted = 29,
    CancellationWithNotice = 30,
    CancellationRejected = 31,
    ServiceUpgradeRequest = 32,
    ServiceDowngradeRequest = 33,
    ServiceUpgradePending = 34,
    ServiceDowngradePending = 35,
    ServiceUpgradeCompleted = 36,
    ServiceDowngradeCompleted = 37,
    ServiceUpgradeCancelled = 38,
    ServiceDowngradeCancelled = 39,
    CancellationAPIFaild = 40,
    ServiceUpgradeAPIFaild = 41,
    ServiceDowngradeAPIFaild = 42,
    ServiceUpgradeIncomplete= 161,
    ServiceDowngradeIncomplete= 162
}

export enum RequestType {
    ChangeofService = 1,
    CancellationofService = 2,
}

export enum DeviceStatusType {
    Available = 1,
    NotAvailable = 2
}

export enum ServiceProviderPriorityType {
    Verylow = 1,
    Low = 2,
    Medium = 3,
    High = 4,
    Veryhigh = 5
}

export enum CategoryType {
    Notification = 1,
    Maintenance = 2,
    Resolution = 3,
    New = 4
}